/* eslint-disable max-len */

import * as R from 'ramda';

export default function HardwareAndSchematicsController(
  $q,
  $filter,
  $timeout,
  $scope,
  $rootScope,
  orgDataService,
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  userService,
) {
  const vm = this;

  vm.hasNetComply = false;
  vm.hasDatto = false;
  vm.hasData = false;

  vm.mainOfficeSchematics = [];
  vm.branchSchematics = [];
  vm.disasterRecoverySchematics = [];

  vm.handleExpand = _handleExpand;

  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.hasData) {
      return $q.all([_loadNetwork(), orgDataService.getCustomerServices(vm.customerId)]).then(response => {
        const services = response[1].data.result;
        const filteredServicesNC = $filter('filter')(services, { name: 'NetComply' });
        vm.hasNetComply = filteredServicesNC.length > 0;
        const filteredServicesEM = $filter('filter')(services, { name: 'Endpoint Management' });
        vm.hasDatto = filteredServicesEM.length > 0 && vm.rmmReportingSource == 2;
        vm.hasData = true;
      });
    }
    return Promise.resolve();
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
    $scope.$on('refreshBCPSchematics', _loadSchematics);
    $scope.$on('refreshBCPWorkstations', _loadWorkstations);
    $scope.$on('refreshBCPServers', _loadServers);
  }

  function _initPermissions() {
    vm.canExpand =
      vm.serverStatus !== '0 Servers Added' ||
      vm.workstationStatus !== '0 WorkStations Added' ||
      vm.schematicStatus !== '0 Schematics Added';
    return userService.getUserPermissionSet('bcp').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _loadNetwork() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getNetwork(vm.assessmentId, true).then(network => {
      loaderService.showViewLoader = false;
      vm.schematics = network.schematics;
      _splitSchematics();
      _handleChangedAssetCount('schematics');

      vm.workstations = network.workstations;
      _handleChangedAssetCount('workstations');

      vm.servers = network.servers;
      _handleChangedAssetCount('servers');

      $rootScope.$broadcast('refreshStatuses');
    });
  }

  function _splitSchematics() {
    const moSchematics = $filter('filter')(vm.schematics, { schematicSectionId: 1 });
    vm.mainOfficeSchematics = R.sortBy(R.prop('name'), moSchematics);

    if (vm.mainOfficeSchematics !== undefined && vm.mainOfficeSchematics.length > 0) {
      R.forEach(item => {
        item.hasImage = false;
        item.imgByteArray = [];
      }, vm.mainOfficeSchematics);
    }

    const bSchematics = $filter('filter')(vm.schematics, { schematicSectionId: 2 });
    vm.branchSchematics = R.sortBy(R.prop('name'), bSchematics);

    if (vm.branchSchematics !== undefined && vm.branchSchematics.length > 0) {
      R.forEach(item => {
        item.hasImage = false;
        item.imgByteArray = [];
      }, vm.branchSchematics);
    }

    const drSchematics = $filter('filter')(vm.schematics, { schematicSectionId: 3 });
    vm.disasterRecoverySchematics = R.sortBy(R.prop('name'), drSchematics);

    if (vm.disasterRecoverySchematics !== undefined && vm.disasterRecoverySchematics.length > 0) {
      R.forEach(item => {
        item.hasImage = false;
        item.imgByteArray = [];
      }, vm.disasterRecoverySchematics);
    }
  }

  function _loadSchematics() {
    loaderService.showViewLoader = true;
    return bcpDataService.getSchematics(vm.assessmentId).then(schematics => {
      loaderService.showViewLoader = false;
      vm.schematics = schematics.data.result;
      _splitSchematics();
      _handleChangedAssetCount('schematics');
      $rootScope.$broadcast('refreshStatuses');
    });
  }

  function _loadWorkstations() {
    loaderService.showViewLoader = true;
    return bcpDataService.getWorkstations(vm.assessmentId).then(workstations => {
      loaderService.showViewLoader = false;
      vm.workstations = workstations.data.result;
      _handleChangedAssetCount('workstations');
      $rootScope.$broadcast('refreshStatuses');
    });
  }

  function _loadServers() {
    loaderService.showViewLoader = true;
    return bcpDataService.getServers(vm.assessmentId).then(servers => {
      loaderService.showViewLoader = false;
      vm.servers = servers.data.result;
      _handleChangedAssetCount('servers');
      $rootScope.$broadcast('refreshStatuses');
    });
  }

  function _handleChangedAssetCount(assetKey) {
    let count = 0;
    let statusPropKey;
    let label = '';

    switch (assetKey) {
      case 'schematics':
        count = vm.schematics.length || 0;
        statusPropKey = 'schematicStatus';
        label = 'Schematic';
        break;
      case 'workstations':
        count = vm.workstations.length || 0;
        statusPropKey = 'workstationStatus';
        label = 'Workstation';
        break;
      case 'servers':
        count = vm.servers.length || 0;
        statusPropKey = 'serverStatus';
        label = 'Server';
        break;
      default:
        return;
    }
    vm[statusPropKey] = bcpSharedModelService.getAssetStatus(label, count);
  }
}

HardwareAndSchematicsController.$inject = [
  '$q',
  '$filter',
  '$timeout',
  '$scope',
  '$rootScope',
  'orgDataService',
  'bcpDataService',
  'bcpSharedModelService',
  'loaderService',
  'userService',
];
